import React, { useState, useEffect } from "react";
import { alertsActions, userActions, locationActions, useSelector } from "inbooma-api";
import { Biscuit, FormatHelper, Notification } from "../../../../utils";
import t from "../../../helpers/t";
import MicroWidget from "../../../components/MicroWidget";

const WidgetUsers = (props) => {
  const [initialized, setInitialized] = useState(
    typeof props.initialized !== "undefined" ? props.initialized : false,
  );
  const [usersCount, setUsersCount] = useState(0);
  const _users = useSelector((state) => state.users_data.users);

  useEffect(() => {
    if (_users.success === "") return;

    if (_users.success === true) {
      setUsersCount(_users.pagination.count);
    } else {
      console.log("Failed to request users!");
    }
  }, [_users]);

  const initialize = () => {
    if (initialized === true) return;
    let filter = {
      find: "!IsEmployee",
      active: 1,
      limit: 1,
      page: 0,
      sort: "created",
      direction: "desc",
    };
    if (typeof props.client_id !== "undefined") {
      filter.client_id = props.client_id;
    }
    props.dispatch(
      userActions.getUsers({
        token: Biscuit.get("token"),
        filter: filter,
      }),
    );
    setInitialized(true);
    if (typeof props.setInitialized !== "undefined") {
      props.setInitialized(true);
    }
  };

  initialize();

  return (
    <>
      <MicroWidget
        position={props.position}
        icon="inb-fi-people"
        title={t("users") + "\n" + t("active")}
        value={usersCount}
      />
    </>
  );
};

export default WidgetUsers;
